import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../services/api';
import '../../css/VerifyEmail.css';

const TestVerifyEmail = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle', 'testing', 'success', 'error'
  const [message, setMessage] = useState('');
  const [result, setResult] = useState(null);

  const handleTest = async () => {
    if (!token.trim()) {
      setMessage('Please enter a verification token');
      return;
    }

    setStatus('testing');
    setMessage('Testing verification token...');

    try {
      console.log('🧪 手动测试令牌:', token.substring(0, 16) + '...');
      
      const response = await apiClient.get(`/auth/verify-email?token=${token}`);
      
      console.log('✅ 测试成功:', response.data);
      setResult(response.data);
      setStatus('success');
      setMessage('Verification successful!');
      
    } catch (error) {
      console.error('❌ 测试失败:', error.response?.data);
      setResult(error.response?.data);
      setStatus('error');
      setMessage(error.response?.data?.message || 'Verification failed');
    }
  };

  const handleDebug = async () => {
    if (!token.trim()) {
      setMessage('Please enter a verification token');
      return;
    }

    try {
      console.error('🔍 调试令牌1:', token.substring(0, 16) + '...');
      console.error('****');
      console.error(token);
      
      const response = await apiClient.get(`/auth/debug-token?token=${token}`);
      
      console.error('🔍 调试结果:', response.data);
      setResult(response.data);
      setStatus('success');
      setMessage('Debug completed');
      
    } catch (error) {
      console.error('❌ 调试失败:', error.response?.data);
      setResult(error.response?.data);
      setStatus('error');
      setMessage('Debug failed');
    }
  };

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        <div className="verify-email-header">
          <h1>Email Verification Test</h1>
        </div>
        
        <div className="verify-email-content">
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
              Verification Token:
            </label>
            <input
              type="text"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Enter the full verification token"
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <button
              onClick={handleTest}
              disabled={status === 'testing'}
              style={{
                background: '#007bff',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '6px',
                marginRight: '10px',
                cursor: status === 'testing' ? 'not-allowed' : 'pointer'
              }}
            >
              {status === 'testing' ? 'Testing...' : 'Test Verification'}
            </button>
            
            <button
              onClick={handleDebug}
              style={{
                background: '#6c757d',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Debug Token
            </button>
          </div>

          {message && (
            <div style={{
              padding: '12px',
              borderRadius: '6px',
              marginBottom: '20px',
              background: status === 'success' ? '#d4edda' : 
                         status === 'error' ? '#f8d7da' : '#d1ecf1',
              color: status === 'success' ? '#155724' : 
                     status === 'error' ? '#721c24' : '#0c5460',
              border: `1px solid ${status === 'success' ? '#c3e6cb' : 
                                   status === 'error' ? '#f5c6cb' : '#bee5eb'}`
            }}>
              {message}
            </div>
          )}

          {result && (
            <div style={{
              background: '#f8f9fa',
              padding: '15px',
              borderRadius: '6px',
              border: '1px solid #dee2e6'
            }}>
              <h4>Result Details:</h4>
              <pre style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: '12px',
                margin: 0
              }}>
                {JSON.stringify(result, null, 2)}
              </pre>
            </div>
          )}

          <div style={{ marginTop: '20px' }}>
            <button
              onClick={() => navigate('/login')}
              style={{
                background: '#6c757d',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestVerifyEmail; 